import { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import Subscription from '../../models/Subscription';
import { EContactCivility } from '@leedpulse-monorepo/enums';

async function createContact(
  payload: CreateContactPayload,
  auth: Authentication
): Promise<void> {
  try {
    await HttpClient.post(
      '/contact',
      payload.toAPIPayload(auth.id),
      auth.token,
      false,
      {
        'x-api-key': payload.subscription.apiKey,
        'x-cms-name': 'leedpulse',
        'x-sender': payload.sender,
      }
    );
    return;
  } catch (e) {
    console.log('error: ', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new CreateContactFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new CreateContactFailure(e.message);
    }
  }
}

export class CreateContactPayload {
  subscription: Subscription;
  civility: EContactCivility;
  firstname: string;
  lastname: string;
  phone: string;
  email: string;
  owner: string;
  details: string;
  sender: string;
  prospectCategory: string;
  company: string;
  adresse: string;
  role: string;
  website: string;
  contactScheduled: boolean;
  contactScheduledDate: Dayjs | null;
  constructor(
    subscription: Subscription,
    civility: EContactCivility = EContactCivility.empty,
    firstname: string,
    lastname: string,
    phone: string,
    email: string,
    owner: string,
    details: string,
    sender: string,
    prospectCategory: string,
    company = '',
    adresse = '',
    role = '',
    website = '',
    contactScheduled = true,
    contactScheduledDate: Dayjs | null = dayjs(),
  ) {
    this.subscription = subscription;
    this.civility = civility;
    this.firstname = firstname;
    this.lastname = lastname;
    this.phone = phone;
    this.email = email;
    this.owner = owner;
    this.details = details;
    this.sender = sender;
    this.prospectCategory = prospectCategory;
    this.company = company;
    this.adresse = adresse;
    this.role = role;
    this.website = website;
    this.contactScheduled = contactScheduled;
    this.contactScheduledDate = contactScheduledDate;
  }

  toAPIPayload(authId: string): Record<string, any> {
    return {
      civility: this.civility,
      firstname: this.firstname,
      lastname: this.lastname,
      email: this.email,
      phone: this.phone,
      details: this.details,
      imported_by: authId,
      owner: this.owner,
      sender: this.sender,
      prospect_category: this.prospectCategory,
      company: this.company,
      adresse: this.adresse,
      role: this.role,
      website: this.website,
      contactScheduled: this.contactScheduled,
      ...(this.contactScheduled ? { contactScheduledDate: this.contactScheduledDate?.valueOf() } : {}),
    };
  }
}

export class CreateContactFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default createContact;
